import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';


@Component({
  templateUrl: 'yes-no-dialog.html',
  host: {'class': 'yes-no-dialog'},
  styleUrls: ['yes-no-dialog.scss']
})
export class YesNoDialogComponent {

  message:string = null;
  html:string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
  ) {

    this.message = _.get(data, 'message', null);
    this.html = _.get(data, 'html', null);

  }






}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/components/yes-no-dialog/yes-no-dialog.ts